import React,{Fragment, Component} from 'react';
import {Link} from 'react-router-dom'; 
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import PageTitle from '../Layout/PageTitle';
import Masonry from 'react-masonry-component';
import SimpleReactLightbox from 'simple-react-lightbox';
import {SRLWrapper, useLightbox} from 'simple-react-lightbox'; 
import AccordionBlog from '../Element/AccordionBlog';
import TestiMonialSlider from '../Element/TestiMonialSlider';
import VideoPopup from '../Element/VideoPopup';
//Images
import bnr1 from './../../images/line2.png';
import bnr2 from './../../images/background/bg5.jpg';
import bnr4 from './../../images/line2.png';
import bgimg2 from './../../images/background/bg1.jpg';
import about from './../../images/about/about-1.jpg';
import gallery1 from './../../images/gallery/pic7.jpg';
import gallery2 from './../../images/gallery/pic2.jpg';
import gallery3 from './../../images/gallery/pic3.jpg';
import gallery4 from './../../images/gallery/pic4.jpg';
import gallery5 from './../../images/gallery/pic5.jpg';
import gallery6 from './../../images/gallery/pic6.jpg';

// Masonry section
const masonryOptions = {                                          
    transitionDuration: 0
};
const imagesLoadedOptions = { background: '.my-bg-image-el' }
// Masonry section end

//Light Gallery Icon
const Iconimage = props => {
	const { openLightbox } = useLightbox()
	return (
		<Link to={"#"}
			onClick={(e) => {
				e.preventDefault()
				openLightbox(props.imageToOpen)
			}} className="check-km" >
			<i className="fa fa-search icon-bx-xs"></i>
		</Link>
	)

}
const galleryBlog = [
	{image: gallery1},	
	{image: gallery2},	
	{image: gallery3},	
	{image: gallery4},	
	{image: gallery5},	
	{image: gallery6},	
];

function BackgroundBlog(){
	return(
		<>
			<div className="container">
				<div className="row">
					<div className="col-lg-12 col-md-12 col-sm-12 col-12  about-text"  style={{visibility: "visible", animationDuration: "2s", animationDelay: "0.2s", animationName: "fadeIn"}}>
						<div className="section-head text-center">
							<div className="video-play">
								<VideoPopup />
							</div>
							<h2>Let Your Kids Have an Amazing<br/>Time at the Park</h2>
							<Link to={"./contact-us"} className="btn btn-md radius-xl">Read More</Link>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

function EducationBanner() {
	return (
		<>
			<div className="section-full bg-white content-inner-2 about-content bg-img-fix" style={{ backgroundImage: "url(" + bgimg2 + ")" }}>
				<div className="about-overlay-box"></div>
				<div className="container">
					<div className="row">
						<div className="col-lg-6 col-md-12 col-sm-12 col-12">
							<div className="section-head">
								<h2 className="head-title text-yellow">Our Curriculum</h2>
								<p className="text-white">Our curriculum aims to combine the benefits of ‘learning by doing’ method with the traditional teacher student Knowledge transfer
									relationship. It is inspired by the U.K. playschools concept which when combined with our traditional Indian Values creates an
									experience that is best of both worlds for our students</p>
							</div>
						</div>
						<div className="col-lg-6 col-md-6 col-sm-12 col-12"></div>
					</div>
				</div>
			</div>
		</>
	)
}

class AboutUs1 extends Component{
	componentDidMount(){
		var splitBox = document.querySelectorAll('.split-box');
       
		var fSB = [].slice.call(splitBox);
		
		fSB.forEach(el => el.classList.add('split-active'));
	}
	render(){
		return(
			<Fragment>
				<Header />	
				 <div className="page-content">
					<PageTitle  motherMenu="About Us"  activeMenu="About Us" />
					<div className="content-block">
						<div className="section-full bg-white content-inner-2 about-area" style={{backgroundImage:"url("+ bnr1 +")", backgroundSize:"contain", backgroundRepeat: "no-repeat",backgroundPosition: "center"}}>
							<div className="container">
								<div className="row">
									<div className="col-lg-6 col-md-12 col-sm-12 m-b15">
										<div className="section-head">
											<h2 className="head-title text-secondry">About the Founder</h2>
											<p>
												Dr. Sadhna Chandna, dual M.A. and PHD, has 30 years of extensive experience in the education sphere. Her
												journey from primary class teacher to Head of Department (HOD) at a prestigious institute (DAV public school)
												is exemplary and clearly demonstrate her passion for teaching and ensuring students success.
												<p></p>
												In 2015, she decided to pursue her long cherished dream of starting her own play school in Noida with a vision
												of building a safe, warm and fun environment for the kids that foster their social, physical and cognitive
												development. Very soon, her unmatched zeal made it a successful and a well-appreciated endeavor.
												At Kimaya, she has been able to augment her decades long experience with a deep understanding of children’s
												psyche to devise an exhaustive and adaptable learning curriculum that focuses on all-round development of
												kids. Her grasp over latest trend in education and her ability to anticipate changing dynamics in the industry
												maximises KIMAYAS’s students chances of getting into their preferred formal schools.
												<p></p>
												Dr Sadhna involves herself in almost all aspects of running the play school. This has been repeatedly
												appreciated by parents and helps to gain their trust and confidence in the school and it’s staff. Due to her strong
												work ethic and dedication she has been awarded and appreciated throughout her career with multiple honours
												and awarded, she brings the same energy and enthusiasm to Kimaya while continuing to learn and grow with the
												school.
											</p>
										</div>
										{/* <AccordionBlog /> */}
									</div>
									<div className="col-lg-6 col-md-12 col-sm-12 teacher-content">
										<div className="split-box">
											<div className="about-media">
												<img src={about} alt=""/>
											</div>
										</div>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 m-b15 text-center">
										<div className="section-head">
											<h2 className="head-title text-secondry">About School</h2>
											<p>Kimaya is deliberately designed to keep a child engaged not just physically but also mentally, the playway method of learning
												that we follow at Kimaya works towards honing children’s senses like vision, touch and hearing to lead to an overall developement. The different
												activities like playing with blocks, coloring, clay , smart board, sports, yoga, aerobics, dance, karate and many more are a regular part of day
												for every child, these activities help develop motor skills early resulting in all round development of children which includes but not limited to psycological, social, creative and physical development.
												<p></p>
												Our curriculum focuses on providing a safe environment for children in which they can discover themselves by being insightful, adventurous
												and simultaneously respectful of others. We put a special emphases on teaching our children to be mindful in every aspect of life, this ensures
												that our children become considerate and thoughtful human beings who are proud of their respective culture and country.
												<p></p>
												The School insists on giving equal to every child and is committed to work with children and their families in the most ethical and sincere way,
												We understand that the families of children studying at Kimaya are part of our fraternity and therefore are given utmost priority and support each
												and every day of the year.
											</p>
										</div>
									</div>
									{/* <div className="col-lg-12 col-md-12 col-sm-12 m-b15">
										<div className="section-head">
											<h2 className="head-title text-secondry">Parent partnership</h2>
											<p>
												We at Kimaya realize that before children come to our school they’ve already started learning from their parents,
												So, it becomes essential to open a bridge between our staff and parents of the ward so that a free and open
												communication channel can function between them. This helps us to customize our attention and techniques
												towards each child so that he/she can benefit from the information flow. We also understand that parents will
												always be the first teachers that a child comes to know so keeping parents and family members in the loop isimperative for a constant growth of the child.
												<p></p>
												Here at Kimaya, we encourage communication between teachers and parents through all forms, even the director of our school
												is always approachable and available in the school, her involvement in all facets of the school gives us an advantage over
												traditional hierarchial models by enhancing a sense of extra care among all staff and ensuring the safety of every child.
											</p>
											<h2 className="head-title text-secondry">Formal School Admission</h2>
											<p>
												To ease the difficult and demanding task of securing admission for your ward in a formal school, we provide consulting, training
												and mock interviews for the parents and their children to maximize the chances of admissions in desired schools. Our school has
												already established a good reputation among all nearby formal schools and this further helps in all aviating parents’ stress.
											</p>
											<h2 className="head-title text-secondry">Educational Trips</h2>
											<p>
												Educational trips are a regular part of the school’s curriculum, we frequently arrange trips to NGOs, museums and more to
												help develop a learning attitude from an early age, today’s children are learning things at an ever faster rate and we leave
												no stone unturned in making sure that they get all means of knowledge gartering. All arrangements are taken care by the
												school including transportation, food and safety.
											</p>
											
										</div>
									</div> */}
								</div>
							</div>
						</div>
						{/* <div className="section-full bg-white content-inner-2 about-content bg-img-fix" style={{backgroundImage:"url(" + bnr2 + ")"}}>
							<BackgroundBlog />
						</div> */}
						{/*  Portfolio  */}
						<EducationBanner />
						<div className="section-full content-inner">
							<div className="container">
								<div className="section-head text-center">
									<h2 className="head-title text-secondry">Gallery</h2>
									{/* <p>We provide three classes with nine to twenty children each aged twelve months to six years of age.</p> */}
								</div>
								<SimpleReactLightbox>
									<SRLWrapper>
										<div className="clearfix" id="lightgallery">
											<ul id="masonry" className="dlab-gallery-listing gallery-grid-4 gallery">
												<Masonry
													className={'my-gallery-class'} 
													options={masonryOptions} 
													disableImagesLoaded={false} 
													updateOnEachImageLoad={false} 
													imagesLoadedOptions={imagesLoadedOptions} // default {}
												>
													{galleryBlog.map((data,index)=>(
														<li className="web design card-container col-lg-4 col-md-6 col-sm-6 "  key={index}>
															<div className="dlab-box frame-box m-b30">
																<div className="dlab-thum dlab-img-overlay1"> 
																	<img src={data.image} alt="" />
																	<div className="overlay-bx">
																		<div className="overlay-icon"> 
																			<Iconimage imageToOpen={index} /> 
																		</div>
																	</div>
																</div>
															</div>
														</li>
													))}
												</Masonry>		
											</ul>
										</div>
									</SRLWrapper>	
								</SimpleReactLightbox>	
							</div>
						</div>
						
						{/* <div className="section-full bg-white content-inner-2" style={{backgroundImage:"url(" + bnr4 +")", backgroundSize:"contain",backgroundRepeat: "no-repeat", backgroundPosition: "center"}}>
							<div className="container">
								<div className="section-head text-center">
									<h2 className="head-title text-secondry">Testimonials about center</h2>
									<p>We have an excellent teacher to child ratio at our Kindergarten to ensure that each child receives the attention he or she needs</p>
								</div>
								<TestiMonialSlider />
							</div>
						</div> */}
					</div>
				</div>	
				<Footer />	
			</Fragment>
		)
	}
}
export { BackgroundBlog, EducationBanner };
export default AboutUs1;